export const ANALYTICS_HOVER_DELAY = 1000;
